
export const BASE_PATH = 'store-v2';
export const ABOUT_PATHS = {
    TERMS_AND_CONDITIONS: 'terms_and_conditions',
    FAQ: 'faq',
    PRIVACY_POLICY: 'privacy_policy'
};

export const getBasePath = () => BASE_PATH;

export const getHomePath = () => `/${getBasePath()}`;

export const getCategoryPath = () => `/${getBasePath()}/category`;

export const getPdpPath = () => `/${getBasePath()}/product`;

export const getCartPath = () => `/${getBasePath()}/cart`;

export const getConfirmationPath = () => `/${getBasePath()}/confirmation`;

export const getPaymentPath = () => `/${getBasePath()}/payment`;

export const getOrderSuccessPath = () => `/${getBasePath()}/confirmation/success`;

export const getOrderFailurePath = () => `/${getBasePath()}/confirmation/failure`;

export const getOrderCancellationPath = () => `/${getBasePath()}/cancellation`;

export const getErrorNoRetryPath = () => `/${getBasePath()}/error-no-retry`;

export const getResumePath = () => `/${getBasePath()}/resume`;

export const getUnsubscribePath = () => `/${getBasePath()}/unsubscribe`;

export const SYNC_FLOW_PATHS = [
    '',
    getHomePath(),
    getCategoryPath(),
    getPdpPath(),
    getCartPath(),
    getResumePath(),
    getUnsubscribePath(),
    getConfirmationPath(),
    getPaymentPath(),
    getOrderSuccessPath(),
    getOrderFailurePath(),
    getOrderCancellationPath(),
    getErrorNoRetryPath(),
    `/${getBasePath()}/self_service/v2/about/${ABOUT_PATHS.TERMS_AND_CONDITIONS}`,
    `/${getBasePath()}/self_service/v2/about/${ABOUT_PATHS.FAQ}`,
    `/${getBasePath()}/self_service/v2/about/${ABOUT_PATHS.PRIVACY_POLICY}`
];
